import superagent from 'superagent';
import config from 'config';
import { getToken } from 'libs/auth';
/*
 * @function "call" common method that makes api requests
 * @param {object} "request" stores the request 'method','endpoint', 'payload', 'query',
 * 'token' as keys...'
 */

const pendingRequests = {};

export default function call({
  method = 'get',
  url,
  endpoint,
  payload,
  query,
  token,
  type = 'application/json'
}) {
  const { API } = config;
  const _url = endpoint ? `${API.backend}/${endpoint}` : url;

  // checking if API is already in progress
  if (pendingRequests[_url]) {
    return pendingRequests[_url];
  }
  pendingRequests[_url] = superagent(method, _url)
    .set('Authorization', `Bearer ${token || getToken()}`)
    .set('Content-Type', type)
    .send(payload)
    .query(query)
    .then((res) => {
      delete pendingRequests[_url];
      return Promise.resolve(res);
    })
    .catch((error) => {
      delete pendingRequests[_url];
      return Promise.reject(error);
    });
  return pendingRequests[_url];
}



// WEBPACK FOOTER //
// ./src/api/apiRequest.js